// extracted by mini-css-extract-plugin
export var cardIcon = "_4s-4";
export var checkboxCard = "_4s-0";
export var checkboxCardSelected = "_4s-1";
export var disabled = "_4s-2";
export var outerBorder = "_4s-3";
export var spacerMedium = "_4s-7";
export var spacerSmall = "_4s-6";
export var spacerXsmall = "_4s-5";